"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Mission() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2867" id="ourmissiondocumentation" className="relative overflow-hidden bg-background py-24 md:py-32 lg:py-44 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute bottom-0 right-0 select-none font-default text-foreground opacity-[0.05] leading-none" style={{
      fontSize: "clamp(220px, 38vw, 520px)"
    }}>
        AZ
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-x-4 gap-y-12 md:gap-x-6 lg:gap-x-8">
          {}
          <div ref={labelRef} className={`col-span-12 md:col-span-3 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default uppercase tracking-[0.2em] text-secondary/80" style={{
            fontSize: "11px"
          }}>
              — 01 / Our Purpose
            </p>
          </div>

          {}
          <div className="col-span-12 md:col-span-9 md:col-start-2">
            <h2 ref={headlineRef} className="font-default font-semibold text-foreground leading-[1.05] tracking-tight" style={{
            fontSize: "clamp(2.5rem, 6vw, 4rem)"
          }}>
              {["A foundation built on", "safety, neutrality,", "and "].map((line, i) => <span key={i} data-index={i} className={`block overflow-hidden`}>
                  <span className={`inline-block transition-all ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"}`} style={{
                transitionDuration: "900ms",
                transitionDelay: `${i * 150}ms`
              }}>
                    {line}
                    {i === 2 && <em className="italic font-normal text-secondary">compassion.</em>}
                  </span>
                </span>)}
            </h2>
          </div>

          {}
          <div ref={textRef} className={`col-span-12 md:col-span-6 md:col-start-2 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
              <p className="font-default text-foreground/85" style={{
              fontSize: "17px",
              lineHeight: 1.7
            }}>
                Tiny to Teen Supervised Parenting & Education Services is a dedicated Arizona agency providing safe, 
                structured, and neutral support for families navigating complex transitions. 
                We prioritize child-centered care in every interaction.
              </p>
              <p className="font-default text-foreground/85 mt-6 sm:mt-0" style={{
              fontSize: "17px",
              lineHeight: 1.7
            }}>
                Our team provides trauma-informed supervision and family support, 
                ensuring that every contact remains steady, professional, and 
                firmly bounded to protect the well-being of all involved.
              </p>
            </div>

            <Separator className="my-10 bg-border" />

            <p className="font-default uppercase tracking-[0.18em] text-secondary/70" style={{
            fontSize: "11px"
          }}>
              Arizona — Supervised Parenting Time & Family Support
            </p>
          </div>

          {}
          <div className="col-span-12 md:col-span-5 md:col-start-8 relative">
            {}
            <div ref={image1Ref} className={`relative z-10 transition-all duration-1000 ease-out ${image1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718652/img/arizona_family_support.png" alt="Professional family support environment in a calm, neutral setting" loading="lazy" decoding="async" className="w-full h-auto aspect-[4/3] object-cover rounded-lg shadow-md" />
            </div>

            {}
            <div ref={image2Ref} className={`relative z-20 -mt-12 sm:-mt-16 md:-mt-20 -ml-0 md:-ml-20 w-[80%] sm:w-[72%] ml-auto md:ml-0 transition-all duration-1000 ease-out delay-200 ${image2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718652/img/professional_neutral_space.webp" alt="A structured and safe space designed for supervised parenting time" loading="lazy" decoding="async" className="w-full h-auto aspect-[3/4] object-cover rounded-lg shadow-lg" />
              <p className="mt-4 italic font-default text-foreground/70" style={{
              fontSize: "14px"
            }}>
                Neutral, child-centered, and secure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}